import { Button } from '@material-ui/core'
import { setShouldIncrementOrderNumber } from '../../VNOrders/ActionCreators'
import { memo, useCallback } from 'react'
import { clearCart } from '../../actions/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import { MODES } from '../../VNMode/Reducer'
import { useDispatch, useSelector } from 'react-redux'
import { getDeviceMode } from '../../VNMode/Selectors'
import { resetCFDrequest } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import styles from './VNClearCartButton.module.scss'
import { ToastManager } from '../../utils/toastManager'
import { APPLICATION_STRINGS } from '../../strings'

const VNClearCartButton = () => {
  const dispatch = useDispatch()
  const cfdMode = useSelector(getDeviceMode)

  const clearItemsAndPromotions = useCallback(() => {
    dispatch(setShouldIncrementOrderNumber())
    dispatch(clearCart())
    dispatch(clearPromotionsOnOrder())
    if (cfdMode === MODES.POS) {
      resetCFDrequest()
    }
    ToastManager.success(APPLICATION_STRINGS.CART_CLEARED)
  }, [dispatch, cfdMode])

  return (
    <div className={styles.container}>
      <Button className={styles.button} onClick={clearItemsAndPromotions}>
        Clear Cart
      </Button>
    </div>
  )
}

export default memo(VNClearCartButton)
